import { createResponseTransformer } from "shared/api/createResponseTransformer"

export const userSpaceResponseTransformer = createResponseTransformer(
  json => json
)
